import { RequestActionPrefix } from '../../request/types'
import * as Types from './types'

export const asQueryString = (filter: Types.Filter): string => {
  return filter ? `${filter.key}=${filter.value}` : ''
}

export const asUpdateBody = (u: Types.StateChange): {} => {
  return { [u.key]: u.new_value }
}

export const filterStatusConstant = (prefix: RequestActionPrefix) => `${prefix}_FILTER_STATUS`
export const updateStatusConstant = (prefix: RequestActionPrefix) => `${prefix}_UPDATE_STATUS`

export const statusFilterFromValue = (value: string, filters: Types.Filter[]): Types.Filter => {
  return filters.filter((p: Types.Filter) => p.value.toString() === value.toString())[0]
}



// WEBPACK FOOTER //
// ./src/components/is_active/utils.ts